// import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useKeycloak } from '../context/KeycloakContext';
import SectionWrapper from '../components/SectionWrapper';
import { useIntl } from 'react-intl';
import Config from '../config/Config';
import '../css/ProfilePage.css';

const ProfilePage = () => {
  const intl = useIntl();

  const {
    isAuthenticated,
    getTimeTokenExpires,
    getUsername,
    getBasyxRoles,
    getRealmRoles,
    getTimeAuthenticated,
    getEmail,
    isEmailVerified,
  } = useKeycloak();

  const basyxRoles = getBasyxRoles() || [];
  const realmRoles = getRealmRoles() || [];
  const { mainColor } = Config.appearance;

  const allRoles = [...basyxRoles, ...realmRoles];

  return (
    <>
      {isAuthenticated() ? (
        <Container className="profile-container my-5">
          <SectionWrapper
            title={intl.formatMessage({ id: 'profile' })}
            titleStyle={{ '--dpp-main-color': mainColor }}
            contentStyle={{ backgroundColor: 'transparent', padding: '15px' }}
          >
            <div className="profile-content" style={{ '--dpp-main-color': mainColor }}>
              <div className="profile-avatar">
                {(getUsername() || '?').slice(0, 2).toUpperCase()}
              </div>
              <dl className="mb-0">
                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'username' })}</dt>
                  <dd className="col-sm-8 profile-dd">{getUsername()}</dd>
                </div>

                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'is_authenticated' })}</dt>
                  <dd className="col-sm-8 profile-dd">
                    {isAuthenticated() ? intl.formatMessage({ id: 'yes' }) : intl.formatMessage({ id: 'no' })}
                  </dd>
                </div>

                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'time_authenticated' })}</dt>
                  <dd className="col-sm-8 profile-dd">
                    {new Date(getTimeAuthenticated() * 1000).toLocaleString()}
                  </dd>
                </div>

                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'expires' })}</dt>
                  <dd className="col-sm-8 profile-dd">
                    {new Date(getTimeTokenExpires() * 1000).toLocaleString()}
                  </dd>
                </div>

                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'email' })}</dt>
                  <dd className="col-sm-8 profile-dd">{getEmail()}</dd>
                </div>

                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'email_verified' })}</dt>
                  <dd className="col-sm-8 profile-dd">
                    {isEmailVerified() ? intl.formatMessage({ id: 'yes' }) : intl.formatMessage({ id: 'no' })}
                  </dd>
                </div>

                <div className="row profile-row">
                  <dt className="col-sm-4 profile-dt">{intl.formatMessage({ id: 'roles' })}</dt>
                  <dd className="col-sm-8 profile-dd">
                    {allRoles.length > 0 ? (
                      allRoles.map((role) => (
                        <span key={role} className="dpp-badge">
                          {role}
                        </span>
                      ))
                    ) : (
                      <span className="profile-no-roles">—</span>
                    )}
                  </dd>
                </div>
              </dl>
            </div>
          </SectionWrapper>
        </Container>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProfilePage;